import { UIText2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './Description.css';

interface IDescriptionProps {
  text: string;
  className?: string;
}

export const Description = ({ text, className }: IDescriptionProps) => {
  return (
    <div className={cn(styles['root'], className)}>
      <UIText2 color="text-secondary-default">{text}</UIText2>
    </div>
  );
};
